"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogEditableTitle = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useAltForSysLang_1 = __importDefault(require("@opsbase/web-ctrl-syslang/SysLangController/useAltForSysLang"));
const useSysLang_1 = __importDefault(require("@opsbase/web-ctrl-syslang/SysLangController/useSysLang"));
const EditIcon_1 = __importDefault(require("@opsbase/web-icons/icons/EditIcon"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const TextField_1 = __importDefault(require("@opsbase/web-textfield/TextField"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const DialogEditableTitle = (props) => {
    const { loading = false, title, titleAlt, editableTitle = false, style, onChangeTitle, onChangeTitleAlt, } = props;
    const { isAlt, language } = (0, useSysLang_1.default)();
    const [localTitle, setLocalTitle] = (0, useAltForSysLang_1.default)(title, titleAlt);
    const dialogTitleWidth = Math.max(((localTitle === null || localTitle === void 0 ? void 0 : localTitle.length) || 0) + 2, 12);
    const handleChangeTitle = (0, react_1.useCallback)(v => {
        if (isAlt)
            return onChangeTitleAlt(Object.assign(Object.assign({}, titleAlt), { [language]: v }));
        return onChangeTitle(v);
    }, [isAlt, language, onChangeTitle, onChangeTitleAlt, titleAlt]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(Pane_1.default, { grow: true },
        loading && react_1.default.createElement(Text_1.default, { variant: "h1" }, lib_i18n_1.default.t('loading')),
        !loading && editableTitle && (react_1.default.createElement(TextField_1.default, { multiline: true, noBorder: true, inputProps: {
                style: Object.assign({ fontSize: 18, fontWeight: 600, lineHeight: '22px', width: dialogTitleWidth + 'ch' }, style),
            }, InputProps: {
                endAdornment: react_1.default.createElement(EditIcon_1.default, { size: 20, color: lib_palette_1.default.Grey }),
            }, value: localTitle, placeholder: lib_i18n_1.default.t('enter-title'), onChange: value => setLocalTitle(value), onBlur: handleChangeTitle })),
        !loading && !editableTitle && title && react_1.default.createElement(Text_1.default, { variant: "h1" }, title))), [
        loading,
        editableTitle,
        dialogTitleWidth,
        style,
        localTitle,
        handleChangeTitle,
        title,
        setLocalTitle,
    ]);
};
exports.DialogEditableTitle = DialogEditableTitle;
exports.default = exports.DialogEditableTitle;
